






import { Vue, Component } from 'vue-property-decorator';
import { getRule } from '../api';

@Component
export default class Rule extends Vue {
  rules = '';
  async created() {
    const ret = await getRule();
    this.rules = ret.data;
  }
}
